import React, { useEffect } from "react";
import { View, ScrollView } from 'react-native'
import { useSelector } from "react-redux";
import {Header,Label,Form} from "../../components/SharedComponents";
import styles from "../../shared/styles";
import { colors, global } from "../../utils";
import localize from "../../shared/localize";

JoinFamily.navigationOptions = () => {
    return { title: localize.Join_a_family_team }
}

export default function JoinFamily(props) {
    const userInfo = useSelector(({ auth }) => auth.userInfo)

    useEffect(() => {
        if (userInfo && userInfo !== null) {
            if (userInfo.family_id !== 0)
                _navigate(global.isNative ? "GetStarted" : "/");
        }
    }, [])

    const _navigate = (pathname, state, search) => {
        if (!global.isNative) {
            return props.history.push({
                pathname: '/' + pathname,
                state,
                search
            });
        }
        return props.navigation.navigate(pathname, state)
    };

    return (
        <View style={styles.container}>
            {
                !global.isNative && (
                    <Header title={localize.Join_a_family_team} goBack={() => _navigate('')} />
                )
            }
            <ScrollView style={{ paddingHorizontal: 20, paddingVertical: 20 }}>
                <View style={{ paddingVertical: 20, alignItems: "center" }}>
                    <Label.PrimaryTitle>
                        {localize.DID_YOU_GET_AN_INVITE}
                    </Label.PrimaryTitle>
                    <View style={{ height: 10 }} />
                    <Label.PrimaryTitle align="center">
                        {localize.If_you_got_an_invite_from_another_family_member}
                    </Label.PrimaryTitle>
                </View>
                <View>
                    <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                        <View style={{ height: 1, backgroundColor: colors.lightGray, width: '46%' }} />
                        <Label.PrimaryTitle align="center" weight="bold" size={14}>
                            {localize.OR}
                        </Label.PrimaryTitle>
                        <View style={{ height: 1, backgroundColor: colors.lightGray, width: '46%' }} />
                    </View>

                    <View style={{ marginVertical: 40 }}>
                        <Label.PrimaryTitle align="center">
                            {localize.ARE_YOU_SETTING_UP_YOUR_FAMILY_TEAM}
                        </Label.PrimaryTitle>
                    </View>
                    <Form.Button
                        title={localize.CREATE_A_FAMILY_TEAM}
                        onPress={() => _navigate(global.isNative ? "CreateTeam" : "create-team")}
                    />
                </View>
            </ScrollView>
        </View>
    );
}